import axios from "../../../config/axiosConfig";

export const lcListUsuarios = ({
  search = "",
  page = 1,
  limit = 200,
  groupBy = 0, // ✅ nuevo
  onlyLinked = 0, // opcional si lo usas
  cod_servicio_cliente, // opcional si lo usas
  cuenta_id, // opcional: solo los usuarios de esa cuenta
} = {}) =>
  axios.get("/api/leasecontrol/usuarios", {
    params: { search, page, limit, groupBy, onlyLinked, cod_servicio_cliente, cuenta_id },
  });

export const lcGetUsuarioDetalle = (itemId) =>
  axios.get(`/api/leasecontrol/usuarios/${itemId}/detalle`);

export const lcCreateUsuario = (body) => axios.post("/api/leasecontrol/usuarios", body);

// Cuentas (accounts) donde se puede crear el usuario, con la que coincide con la razón social del cliente marcada como sugerida.
export const lcListCuentas = (cod_servicio_cliente) =>
  axios.get("/api/leasecontrol/cuentas", { params: { cod_servicio_cliente } });

// ✅ Unificado: nombre / password / enabled / todo
export const lcUpdateUsuario = (body) => axios.patch("/api/leasecontrol/usuarios", body);

export const lcDeleteUsuario = (itemId) =>
  axios.delete("/api/leasecontrol/usuarios/", { data: { itemId } });

// Solo quita la vinculación local con el cliente — no borra el usuario en Leasecontrol.
// cod_servicio_cliente es opcional pero recomendado: un usuario puede tener
// vinculaciones activas con más de un cliente (ver Panel Global), así que sin
// ese dato el backend podría desvincular la de otro cliente distinto.
export const lcDesvincularUsuario = (itemId, codServicioCliente) =>
  axios.post(`/api/leasecontrol/usuarios/${itemId}/desvincular`, {
    cod_servicio_cliente: codServicioCliente,
  });

export const lcListUnidades = ({ search = "", page = 1, limit = 25 } = {}) =>
  axios.get("/api/leasecontrol/unidades", { params: { search, page, limit } });

export const lcListHwTypes = ({ search = "", page = 1, limit = 30 } = {}) =>
  axios.get("/api/leasecontrol/hw-types", { params: { search, page, limit } });

export const lcListIconLibrary = ({ type = "unit", flags = 0, resId = 0, size = 64 } = {}) =>
  axios.get("/api/leasecontrol/iconos-biblioteca", { params: { type, flags, resId, size } });

export const lcListChipsDisponibles = ({ search = "", limit = 20 } = {}) =>
  axios.get("/api/leasecontrol/chips-disponibles", { params: { search, limit } });

// `cuentas`: ids de cuenta (separados por coma) para listar solo los grupos de esas cuentas.
export const lcListUnitGroups = ({ search = "", page = 1, limit = 30, cuentas = "" } = {}) =>
  axios.get("/api/leasecontrol/grupos-unidades", { params: { search, page, limit, cuentas: cuentas || undefined } });

export const lcCreateUnitGroup = (body) =>
  axios.post("/api/leasecontrol/grupos-unidades", body);

export const lcUpdateUnitGroup = (itemId, body) =>
  axios.patch(`/api/leasecontrol/grupos-unidades/${itemId}`, body);

export const lcGetUnitGroupHistory = (itemId, { page = 1, limit = 30 } = {}) =>
  axios.get(`/api/leasecontrol/grupos-unidades/${itemId}/historial`, { params: { page, limit } });

export const lcCreateUnidad = (body) =>
  axios.post("/api/leasecontrol/unidades", body);

export const lcUpdateUnidad = (sysId, body) =>
  axios.patch(`/api/leasecontrol/unidades/${sysId}`, body);

export const lcDeleteUnidad = (sysId) =>
  axios.delete(`/api/leasecontrol/unidades/${sysId}`);

export const lcSyncUnidad = (sysId) =>
  axios.post(`/api/leasecontrol/unidades/${sysId}/sincronizar`);

export const searchClienteServicio = ({
  codServicio = 2,
  limit = 20,
  nombreCliente = "",
  estado = "Activo",
} = {}) =>
  axios.get("/api/cliente-servicio", {
    params: { codServicio, limit, nombreCliente, estado },
  });

export const getClienteServicioById = (cod_servicio_cliente) =>
  axios.get(`/api/cliente-servicio/${cod_servicio_cliente}`);

// Admin/sistemas: copia un usuario de Wialon a Leasecontrol (usuario + grupos vacíos).
export const lcCopiarUsuarioDesdeWialon = (body) =>
  axios.post("/api/leasecontrol/usuarios/copiar-desde-wialon", body);
